import { ReactElement, ReactNode } from "react"
import { useParams } from "react-router-dom"

import CreateEVDCDeviceProvider from "./baseProviders/createEVDCDeviceProvider"
import useContinueEVDCDeviceDraft from "../../../../../services/middleware/hooks/devices/lct/useContinueEVDCDeviceDraft"

interface IContinueEVDCDeviceVersionUrlParams {
    deviceRef: string
}

interface IContinueEVDCDeviceVersionProviderProps {
    children: ReactNode
}

const ContinueEVDCDeviceVersionProvider = ({
    children,
}: IContinueEVDCDeviceVersionProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof IContinueEVDCDeviceVersionUrlParams
    >() as IContinueEVDCDeviceVersionUrlParams

    const {
        data: formData,
        setData: setFormData,
        isLoading,
        error: continueVersionError,
        attachmentUUID,
    } = useContinueEVDCDeviceDraft(urlDeviceRef)

    return (
        <CreateEVDCDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={isLoading}
            formDataError={continueVersionError}
            attachmentUUID={attachmentUUID ?? undefined}
            systemReference={urlDeviceRef}
            canEditManufacturer={false}
        >
            {children}
        </CreateEVDCDeviceProvider>
    )
}

export default ContinueEVDCDeviceVersionProvider
